var Education = "Pendidikan";
var Enterprise = "Korporasi";
var CompanyType = {
	"Company type": "Tipe Perusahaan",
	Education: Education,
	Enterprise: Enterprise,
	"Government - Federal": "Pemerintahan - Federal",
	"Government - State & local": "Pemerintahan - Negara Bagian & Daerah",
	"Non-profit": "Nirlaba",
	"Self employed": "Wirausaha",
	"Small-medium business": "Usaha Kecil Menengah",
	"Start-up": "Startup",
	"Not applicable": "Tidak Berlaku"
};

export { Education, Enterprise, CompanyType as default };
